/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import jMoment from 'moment-jalaali'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import TMS from '../BaseComponent/TMS'
import FromToPicker from '../BaseComponent/FromToPicker'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Bar} from 'react-chartjs-2'
import {roundTo} from '../utils/convert'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'

class PercentFunctionality extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      list: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      getSort: '',
      modalDelete: false,
      fromDate: '',
      toDate: '',
      excelReport: [],
      sortData: [
        {name: 'ردیف', value: 'id', sorted: false, direction: null, sortable: false},
        {name: 'عنوان', value: 'title', sorted: false, direction: null, sortable: false},
        {name: 'تعداد فعالیت', value: 'activityCount', sorted: false, direction: null, sortable: false},
        {name: 'تعداد روز کاری', value: 'dayCount', sorted: false, direction: null, sortable: false},
        {name: 'ضریب عملکرد نسبت به حداقل', value: 'copUserMin', sorted: false, direction: null, sortable: true},
        {name: 'ضریب عملکرد نسبت به میانگین', value: 'copUserAvg', sorted: false, direction: null, sortable: true},
        {name: 'ضریب عملکرد نسبت به حداکثر', value: 'copUserMax', sorted: false, direction: null, sortable: true},
        {name: 'ضریب عملکرد نسبت به حداقل', value: 'copOperatorMin', sorted: false, direction: null, sortable: true},
        {name: 'ضریب عملکرد نسبت به میانگین', value: 'copOperatorAvg', sorted: false, direction: null, sortable: true},
        {name: 'ضریب عملکرد نسبت به حداکثر', value: 'copOperatorMax', sorted: false, direction: null, sortable: true},
        {name: 'نمودار', value: '', sorted: false, direction: null, sortable: false},
        {name: 'جزییات', value: '', sorted: false, direction: null, sortable: false}
      ],
      chartData: {},
      chartData2: {},
      chartCountUser: {},
      chartCountOperator: {},
      chart: false,
      userCharts: false,
      operatorCharts: false,
      userChartsData: {},
      operatorChartsData: {},
      userChartsCount: false,
      userChartsCountData: {},
      operatorChartsCount: false,
      operatorChartsCountData: {},
      department: [],
      operators: [],
      personId: {
        personId: ''
      }
    }
  }

  getAll = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          $('.showBaseTable').fadeIn()

          if (!exportStatus) {
            this.setState({
              list: res.data.object.result,
              lengthProducts: res.data.object.countAll,
              loading: false
            })
          } else if (exportStatus) {
            this.setState({
              printInfo: res.data.object.result,
              loading: false
            })
          }
        } else {
          $('.showBaseTable').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.basketFilterComponent').slideUp()
      })
    })
    // this.getAll(false)

    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAll(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAll(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAll(false)
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let grouping = $('#grouping').val()
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    let departmentId = $('#departmentId').val()

    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (grouping !== '' && grouping.length) {
      filter.grouping = grouping
    }
    if (activityDateMin !== '') {
      filter.activityDateMin = activityDateMin
    }
    if (activityDateMax !== '') {
      filter.activityDateMax = activityDateMax
    }
    if (departmentId !== '' && departmentId.length) {
      filter.departmentId = departmentId
    }
    if (this.state.personId !== '') {
      filter.personId = this.state.personId.personId
    }

    return filter
  }

  filter() {
    let grouping = $('#grouping').val()
    let departmentId = $('#departmentId').val()
    let activityDateMin = this.state.fromDate
    let activityDateMax = this.state.toDate
    if (grouping === 'user') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}&personId=`
      )
    } else if (grouping === 'department') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}`
      )
    } else if (grouping === 'section') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=${departmentId}&sectionId=`
      )
    } else if (grouping === 'task') {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&taskId=${departmentId}`
      )
    } else {
      sessionStorage.setItem(
        'params',
        `activityDateMax=${activityDateMax}&activityDateMin=${activityDateMin}&departmentId=`
      )
    }
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getAll(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].activityCount = this.convertCount(excelReport[i].activityCount)
          }
          this.setState({
            excelReport: res.data.object.result
          })
          this._export.save(this.state.excelReport)
        }
      })
  }

  getPrintInfo = () => {
    this.getAll(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }
  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getValueOperator = (personId) => {
    if (personId === null) {
      this.setState({
        personId: ''
      })
    } else {
      this.setState({
        personId
      })
    }
  }

  openChart = (
    minUser,
    avgUser,
    maxUser,
    minOperator,
    avgOperator,
    maxOperator,
    countMinUser,
    countAvgUser,
    countMaxUser,
    countMinOp,
    countAvgOp,
    countMaxOp,
    countUser
  ) => {
    this.setState({
      chartData: {
        labels: ['حداقل', 'میانگین', 'حداکثر'],
        datasets: [
          {
            label: 'کاربر',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: [minUser, avgUser, maxUser]
          },
          {
            label: 'سرپرست',
            backgroundColor: 'rgba(0,55,255,0.2)',
            borderColor: 'rgba(0,55,255,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(0,55,255,0.4)',
            hoverBorderColor: 'rgba(0,55,255,0.6)',
            data: [minOperator, avgOperator, maxOperator]
          }
          // {
          //     label: 'نسبت پایه',
          //     backgroundColor: 'transparent',
          //     borderColor: '#A303FF',
          //     borderWidth: 1,
          //     data: [1,1,1],
          //     type: 'line'
          // }
        ]
      },
      chartData2: {
        // labels: ['کاربر', 'سرپرست', 'نرمال'],
        labels: ['کاربر', 'سرپرست'],
        datasets: [
          {
            label: 'حداقل',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: [minUser, minOperator]
          },
          {
            label: 'میانگین',
            backgroundColor: 'rgba(0,55,255,0.2)',
            borderColor: 'rgba(0,55,255,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(0,55,255,0.4)',
            hoverBorderColor: 'rgba(0,55,255,0.6)',
            data: [avgUser, avgOperator]
          },
          {
            label: 'حداکثر',
            backgroundColor: 'rgba(0,255,62,0.2)',
            borderColor: 'rgba(0,255,62,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(0,255,62,0.4)',
            hoverBorderColor: 'rgba(0,255,62,0.6)',
            data: [maxUser, maxOperator]
          }
          // {
          //     label: 'نسبت پایه',
          //     backgroundColor: 'transparent',
          //     borderColor: '#A303FF',
          //     borderWidth: 1,
          //     data: [1,1],
          //     type: 'line'
          // }
        ]
      }
      // chartCountUser : {
      //     labels: ['حداقل', 'میانگین', 'حداکثر'],
      //     datasets: [
      //         {
      //             label: 'کاربر',
      //             backgroundColor: 'rgba(255,99,132,0.2)',
      //             borderColor: 'rgba(255,99,132,1)',
      //             borderWidth: 1,
      //             hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      //             hoverBorderColor: 'rgba(255,99,132,1)',
      //             data: [countMinUser, countAvgUser,  countMaxUser]
      //         },
      //         {
      //             label: 'سرپرست',
      //             backgroundColor: 'rgba(0,55,255,0.2)',
      //             borderColor: 'rgba(0,55,255,1)',
      //             borderWidth: 1,
      //             hoverBackgroundColor: 'rgba(0,55,255,0.4)',
      //             hoverBorderColor: 'rgba(0,55,255,0.6)',
      //             data: [countMinOp, countAvgOp, countMaxOp]
      //         },
      //         {
      //             label: 'تعداد ثبت شده',
      //             backgroundColor: 'transparent',
      //             borderColor: '#A303FF',
      //             borderWidth: 1,
      //             data: [countUser, countUser, countUser],
      //             type: 'line'
      //         }
      //     ]
      // },
      // chartCountOperator : {
      //     // labels: ['کاربر', 'سرپرست', 'نرمال'],
      //     labels: ['کاربر', 'سرپرست'],
      //     datasets: [
      //         {
      //             label: 'حداقل',
      //             backgroundColor: 'rgba(255,99,132,0.2)',
      //             borderColor: 'rgba(255,99,132,1)',
      //             borderWidth: 1,
      //             hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      //             hoverBorderColor: 'rgba(255,99,132,1)',
      //             data: [countMinUser, countMinOp]
      //         },
      //         {
      //             label: 'میانگین',
      //             backgroundColor: 'rgba(0,55,255,0.2)',
      //             borderColor: 'rgba(0,55,255,1)',
      //             borderWidth: 1,
      //             hoverBackgroundColor: 'rgba(0,55,255,0.4)',
      //             hoverBorderColor: 'rgba(0,55,255,0.6)',
      //             data: [countAvgUser, countAvgOp]
      //         },
      //         {
      //             label: 'حداکثر',
      //             backgroundColor: 'rgba(0,255,62,0.2)',
      //             borderColor: 'rgba(0,255,62,1)',
      //             borderWidth: 1,
      //             hoverBackgroundColor: 'rgba(0,255,62,0.4)',
      //             hoverBorderColor: 'rgba(0,255,62,0.6)',
      //             data: [countMaxUser, countMaxOp]
      //         },
      //         {
      //             label: 'تعداد ثبت شده',
      //             backgroundColor: 'transparent',
      //             borderColor: '#A303FF',
      //             borderWidth: 1,
      //             data: [countUser, countUser],
      //             type: 'line'
      //         }
      //     ]
      // },
    })
    setTimeout(() => {
      this.setState({
        chart: true
      })
    }, 1000)
  }

  async userChart() {
    let filter = this.createFilter(true)
    await http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let datasets = res.data.object.result
          let arrayTitle = []
          let arrayMin = []
          let arrayMax = []
          let arrayAvg = []
          for (let i in datasets) {
            arrayTitle.push(datasets[i].title)
            arrayMin.push(datasets[i].copUserMin)
            arrayMax.push(datasets[i].copUserMax)
            arrayAvg.push(datasets[i].copUserAvg)
          }
          this.setState({
            userChartsData: {
              labels: arrayTitle,
              datasets: [
                {
                  label: 'حداقل',
                  backgroundColor: 'rgba(255,99,132,0.2)',
                  borderColor: 'rgba(255,99,132,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                  hoverBorderColor: 'rgba(255,99,132,1)',
                  data: arrayMin
                },
                {
                  label: 'میانگین',
                  backgroundColor: 'rgba(0,55,255,0.2)',
                  borderColor: 'rgba(0,55,255,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,55,255,0.4)',
                  hoverBorderColor: 'rgba(0,55,255,0.6)',
                  data: arrayAvg
                },
                {
                  label: 'حداکثر',
                  backgroundColor: 'rgba(0,255,62,0.2)',
                  borderColor: 'rgba(0,255,62,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,255,62,0.4)',
                  hoverBorderColor: 'rgba(0,255,62,0.6)',
                  data: arrayMax
                }
              ]
            }
          })
        }
      })

    setTimeout(() => {
      this.setState({
        userCharts: true
      })
    }, 1000)
  }

  async operatorChart() {
    let filter = this.createFilter(true)
    await http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let datasets = res.data.object.result
          let arrayTitle = []
          let arrayMin = []
          let arrayMax = []
          let arrayAvg = []
          for (let i in datasets) {
            arrayTitle.push(datasets[i].title)
            arrayMin.push(datasets[i].copOperatorMin)
            arrayMax.push(datasets[i].copOperatorMax)
            arrayAvg.push(datasets[i].copOperatorAvg)
          }
          this.setState({
            operatorChartsData: {
              labels: arrayTitle,
              datasets: [
                {
                  label: 'حداقل',
                  backgroundColor: 'rgba(255,99,132,0.2)',
                  borderColor: 'rgba(255,99,132,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                  hoverBorderColor: 'rgba(255,99,132,1)',
                  data: arrayMin
                },
                {
                  label: 'میانگین',
                  backgroundColor: 'rgba(0,55,255,0.2)',
                  borderColor: 'rgba(0,55,255,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,55,255,0.4)',
                  hoverBorderColor: 'rgba(0,55,255,0.6)',
                  data: arrayAvg
                },
                {
                  label: 'حداکثر',
                  backgroundColor: 'rgba(0,255,62,0.2)',
                  borderColor: 'rgba(0,255,62,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,255,62,0.4)',
                  hoverBorderColor: 'rgba(0,255,62,0.6)',
                  data: arrayMax
                }
              ]
            }
          })
        }
      })

    setTimeout(() => {
      this.setState({
        operatorCharts: true
      })
    }, 1000)
  }

  async activityCountChart() {
    let filter = this.createFilter(true)
    await http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let datasets = res.data.object.result
          let arrayTitle = []
          let array = []
          let arrayMax = []
          let arrayAvg = []
          for (let i in datasets) {
            arrayTitle.push(datasets[i].title)
            array.push(datasets[i].activityCount)
          }
          this.setState({
            userChartsCountData: {
              labels: arrayTitle,
              datasets: [
                {
                  label: 'تعداد',
                  backgroundColor: 'rgba(0,255,62,0.2)',
                  borderColor: 'rgba(0,255,62,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,255,62,0.4)',
                  hoverBorderColor: 'rgba(0,255,62,0.6)',
                  data: array
                }
              ]
            }
          })
        }
      })

    setTimeout(() => {
      this.setState({
        userChartsCount: true
      })
    }, 1000)
  }

  async dayCountChart() {
    let filter = this.createFilter(true)
    await http
      .get(`${TMS.TMS_REPORT_ACTIVITY_PERCENT_SIMPLE}`, {
        params: filter
      })
      .then((res) => {
        if (res.data.error === null) {
          let datasets = res.data.object.result
          let arrayTitle = []
          let array = []
          for (let i in datasets) {
            arrayTitle.push(datasets[i].title)
            array.push(datasets[i].dayCount)
          }
          this.setState({
            operatorChartsCountData: {
              labels: arrayTitle,
              datasets: [
                {
                  label: 'تعداد',
                  backgroundColor: 'rgba(0,55,255,0.2)',
                  borderColor: 'rgba(0,55,255,1)',
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(0,55,255,0.4)',
                  hoverBorderColor: 'rgba(0,55,255,0.6)',
                  data: array
                }
              ]
            }
          })
        }
      })

    setTimeout(() => {
      this.setState({
        operatorChartsCount: true
      })
    }, 1000)
  }

  convertCount = (count) => {
    if (count !== null) {
      return count.toFixed(1).replace('.0', '')
    } else {
      return ''
    }
  }

  render() {
    let options = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-1',
            display: true,
            position: 'left',
            ticks: {
              callback: function(value, index, values) {
                return value
              },
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'نسبت زمانی',
              fontColor: '#546372'
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: false
            }
          }
        ]
      }
    }
    let countOptions = {
      scales: {
        yAxes: [
          {
            id: 'y-axis-1',
            display: true,
            position: 'left',
            ticks: {
              callback: function(value, index, values) {
                return value
              },
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'تعداد',
              fontColor: '#546372'
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: false
            }
          }
        ]
      }
    }

    let {pageNumber, pageSize, loading} = this.state
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'عنوان',
      'تعداد فعالیت',
      'تعداد روز کاری',
      'ضریب عملکرد نسبت به حداقل',
      'ضریب عملکرد نسبت به میانگین',
      'ضریب عملکرد نسبت به حداکثر',
      'ضریب عملکرد نسبت به حداقل',
      'ضریب عملکرد نسبت به میانگین',
      'ضریب عملکرد نسبت به حداکثر'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش نسبت عملکرد"
              headerColSpan={10}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={5}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={columns}
              groupCol={
                <tr style={{border: '1px solid #000'}}>
                  <td colSpan={2} />
                  <td colSpan={2}>عملکرد کاربر</td>
                  <td colSpan={3}>زمان اعلام شده</td>
                  <td colSpan={3}>زمان تایید شده</td>
                </tr>
              }
            />
            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{list.title}</td>
                  <td>{this.convertCount(list.activityCount)}</td>
                  <td>{list.dayCount}</td>
                  <td>{roundTo(list.copUserMin)}</td>
                  <td>{roundTo(list.copUserAvg)}</td>
                  <td>{roundTo(list.copUserMax)}</td>
                  <td>{roundTo(list.copOperatorMin)}</td>
                  <td>{roundTo(list.copOperatorAvg)}</td>
                  <td>{roundTo(list.copOperatorMax)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش نسبت عملکرد.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'activityCount'}
                field={'activityCount'}
                title={'تعداد فعالیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'dayCount'}
                field={'dayCount'}
                title={'تعداد روز کاری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'copUserMin'}
                field={'copUserMin'}
                title={'ضریب عملکرد نسبت به حداقل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'copUserAvg'}
                field={'copUserAvg'}
                title={'ضریب عملکرد نسبت به میانگین'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'copUserMax'}
                field={'copUserMax'}
                title={'ضریب عملکرد نسبت به حداکثر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'copOperatorMin'}
                field={'copOperatorMin'}
                title={'ضریب عملکرد نسبت به حداقل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'copOperatorAvg    '}
                field={'copOperatorAvg'}
                title={'ضریب عملکرد نسبت به میانگین'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'copOperatorMax'}
                field={'copOperatorMax'}
                title={'ضریب عملکرد نسبت به حداکثر'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مدیریت فعالیت ها</li>
            <li>گزارشات</li>
            <li>گزارش نسبت عملکرد</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
                <button className="printButton" style={{width: '100px'}} onClick={this.userChart.bind(this)}>
                  نمودار کاربر(نسبت زمانی)
                </button>
                <button className="printButton" style={{width: '100px'}} onClick={this.operatorChart.bind(this)}>
                  نمودار سرپرست (نسبت زمانی)
                </button>
                <button className="printButton" style={{width: '100px'}} onClick={this.activityCountChart.bind(this)}>
                  نمودار تعداد فعالیت
                </button>
                <button className="printButton" style={{width: '100px'}} onClick={this.dayCountChart.bind(this)}>
                  نمودار تعداد روز کاری
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel=" تاریخ فعالیت از"
                  toLabel=" تاریخ فعالیت تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>گروهبندی</label>
                  <select className="form-control" id="grouping">
                    <option value="">------</option>
                    <option value="user" selected>
                      کاربر
                    </option>
                    <option value="department">دپارتمان</option>
                    <option value="section">واحد سازمانی</option>
                    <option value="task">وظیفه</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    دپارتمان
                  </label>
                  <select className="custom-select" name="departmentId" id="departmentId">
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.operators}
                    getValueCombo={this.getValueOperator}
                    lableText="کاربران"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr>
                    <td colSpan={2} />
                    <td colSpan={2}>عملکرد کاربر</td>
                    <td colSpan={3}>زمان اعلام شده</td>
                    <td colSpan={3}>زمان تایید شده</td>
                    <td colSpan={2} />
                  </tr>

                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.list.map((list, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{list.title}</td>
                      <td>{this.convertCount(list.activityCount)}</td>
                      <td>{list.dayCount}</td>
                      <td>{roundTo(list.copUserMin)}</td>
                      <td>{roundTo(list.copUserAvg)}</td>
                      <td>{roundTo(list.copUserMax)}</td>
                      <td>{roundTo(list.copOperatorMin)}</td>
                      <td>{roundTo(list.copOperatorAvg)}</td>
                      <td>{roundTo(list.copOperatorMax)}</td>
                      <td>
                        <button
                          onClick={() =>
                            this.openChart(
                              list.copUserMin,
                              list.copUserAvg,
                              list.copUserMax,
                              list.copOperatorMin,
                              list.copOperatorAvg,
                              list.copOperatorMax,
                              list.countUserMin,
                              list.countUserAvg,
                              list.countUserMax,
                              list.countOperatorMin,
                              list.countOperatorAvg,
                              list.countOperatorMax,
                              list.countUser
                            )
                          }
                        >
                          <img src={require('../../image/details.svg')} />
                        </button>
                      </td>
                      <td>
                        <Link
                          to={`/detailsFunctionality?id=${list.id}&fromDate=${this.state.fromDate}&toDate=${
                            this.state.toDate
                          }`}
                          target={'_blank'}
                        >
                          <img src={require('../../image/details.svg')} />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthProducts}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.userCharts} toggle={() => this.setState({userCharts: false})} size="lg">
          <ModalHeader toggle={() => this.setState({userCharts: false})}>نمودار کاربر</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between">
              <Bar data={this.state.userChartsData} width={100} height={50} min={0} options={options} />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({userCharts: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.operatorCharts} toggle={() => this.setState({operatorCharts: false})} size="lg">
          <ModalHeader toggle={() => this.setState({operatorCharts: false})}>نمودار سرپرست</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between">
              <Bar data={this.state.operatorChartsData} width={100} height={50} min={0} options={options} />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({operatorCharts: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.chart} toggle={() => this.setState({chart: false})} size="lg">
          <ModalHeader toggle={() => this.setState({chart: false})}>نمودار</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between flex-wrap">
              <div style={{width: '50%', height: '200px'}}>
                <Bar data={this.state.chartData} width={100} height={50} min={0} options={options} />
              </div>

              <div style={{width: '50%', height: '200px'}}>
                <Bar data={this.state.chartData2} width={100} height={50} min={0} options={options} />
              </div>
              {/*<div style={{width:'50%',height:'200px'}}>*/}
              {/*    <Bar*/}
              {/*        data={this.state.chartCountUser}*/}
              {/*        width={100}*/}
              {/*        height={50}*/}
              {/*        min={0}*/}
              {/*        options={countOptions}*/}
              {/*    />*/}
              {/*</div>*/}
              {/*<div style={{width:'50%',height:'200px'}}>*/}
              {/*    <Bar*/}
              {/*        data={this.state.chartCountOperator}*/}
              {/*        width={100}*/}
              {/*        height={50}*/}
              {/*        min={0}*/}
              {/*        options={countOptions}*/}
              {/*    />*/}
              {/*</div>*/}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({chart: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.userChartsCount} toggle={() => this.setState({userChartsCount: false})} size="lg">
          <ModalHeader toggle={() => this.setState({userChartsCount: false})}>نمودار تعداد فعالیت</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between">
              <Bar data={this.state.userChartsCountData} width={100} height={50} min={0} options={countOptions} />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({userChartsCount: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.operatorChartsCount}
          toggle={() => this.setState({operatorChartsCount: false})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({operatorChartsCount: false})}>نمودار تعداد روز کاری</ModalHeader>
          <ModalBody>
            <div className="d-flex justify-content-between">
              <Bar data={this.state.operatorChartsCountData} width={100} height={50} min={0} options={countOptions} />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({operatorChartsCount: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default PercentFunctionality
